import st from './CropsFilter.module.scss';
import React, { useState } from "react";
import { SelectorCropTNode } from "../../../../../store/reducers/dashboard/crops/selector/types";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { IconBox, Input, Type as T } from "@infobis/ui-styles-utils";
import colors from "@infobis/ui-styles-utils/colors";
import CropsFilterList from "@layouts/headerDashboardLayout/components/CropsFilterList/CropsFilterList";

type CropsFilterProps = {
	pickedCrops: SelectorCropTNode[]
	setPickedCrops: (crops: SelectorCropTNode[]) => void
}

const CropsFilter = ({ setPickedCrops, pickedCrops }: CropsFilterProps) => {
	const [searchValue, setSearchValue] = useState('');
	const { data, isApiLoading } = useTypedSelector(state => state.cropSelector)

	const onSelectCrop = (node: SelectorCropTNode, selected: boolean) => {
		if (selected) setPickedCrops([...pickedCrops, node])
		else setPickedCrops(pickedCrops.filter(pickedNode => pickedNode.id !== node.id))
	}

	const onSelectAll = (mode: 'select' | 'deselect') => {
		mode === 'select' ? setPickedCrops(data) : setPickedCrops([])
	}

	return (
		<div className={st['crops']}>
			<span className={st['crops__title']}>Культуры</span>
			<Input.Text maskProps={undefined}
						size={T.Sizes.M}
						color={T.Variant.CLEAR}
						inputClassName={st['crops__input']}
						width={'full'}
						value={searchValue}
						onChange={setSearchValue}
						placeholder={'Поиск'}
						iconBefore={() => <IconBox icon={T.IconName.Search}
												   size={T.Sizes.M}
												   color={colors.CONTROL_DEFAULT_ICON_ICON} />
						} />
			{isApiLoading
				? <span className={st['crops__loading']}>Культуры загружаются...</span>
				: <CropsFilterList selectAll={onSelectAll}
								   searchValue={searchValue}
								   selected={pickedCrops}
								   onClick={onSelectCrop}
								   data={data} />
			}
		</div>
	)
}

export default CropsFilter;